import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-754b7437"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-notes" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "sr-only" }, "Notes", -1))
const _hoisted_3 = { class: "actions mobile-fixed-actions" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.additionalNote) = $event)),
      placeholder: "Any additional information you can provide will improve the accuracy of the estimates you receive.",
      class: "form-control"
    }, "\n    ", 512), [
      [_vModelText, _ctx.additionalNote]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn-outline-light",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToServicesStep()))
      }, [
        _createVNode(_component_icon, { icon: ['far', 'plus'] }),
        _createTextVNode(" Add another service ")
      ]),
      _createElementVNode("button", {
        disabled: _ctx.loading,
        class: "btn btn-primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToNextStep()))
      }, [
        _createTextVNode(" Next "),
        _createVNode(_component_icon, { icon: ['fal', 'arrow-right'] })
      ], 8, _hoisted_4)
    ])
  ]))
}